import React from "react";
import { DA_BasicLink } from "@danishagro/shared/src/components/atoms/BasicLink/BasicLink.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { formatNumber } from "@danishagro/shared/src/helpers/formatNumber.helper";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { DA_EmptyStateNoPrice } from "@danishagro/b2c/src/components/molecules/EmptyState/NoPrice/NoPrice.component";
import { DA_OrderHistoryLines } from "@danishagro/shared/src/interfaces/orderHistory.interface";
import { B2bImageSrc } from "@danishagro/shared/src/helpers/imageSrc.helper";
import { ImageConfig } from "@danishagro/shared/src/content/imageConfigs/imageConfig.enum";
import S from "./OrderDetailsProduct.module.scss";

interface OrderDetailsProductWrapperProps {
    lines: DA_OrderHistoryLines[];
}

export const OrderDetailsProduct: React.FC<OrderDetailsProductWrapperProps> = ({ lines }) => {
    const { getDictionaryItem } = useTranslations();
    const { currentCulture } = useAppData();

    return (
        <>
            {lines?.length > 0 && (
                <div className={S.productWrapper}>
                    {lines.map((line) => {
                        const ImageContent = (
                            <img
                                src={B2bImageSrc(line.imageUrl, ImageConfig.PdpThumbnail)}
                                alt=""
                                width={85}
                                height={85}
                                className={S.image}
                            />
                        );

                        return (
                            <div key={line.id} className={S.product}>
                                {/** Image */}
                                <div className={S.productImage}>
                                    {line.url ? (
                                        <DA_BasicLink href={line.url} className={S.imageLink}>
                                            {ImageContent}
                                        </DA_BasicLink>
                                    ) : (
                                        ImageContent
                                    )}
                                </div>

                                <span className={S.description}>
                                    {line.url ? (
                                        <DA_BasicLink href={line.url} className={S.nameLink}>
                                            {line.name}
                                        </DA_BasicLink>
                                    ) : (
                                        line.name
                                    )}
                                </span>

                                <span className={S.pcs}>
                                    {formatNumber(line.quantity, currentCulture)}{" "}
                                    {getDictionaryItem("general.pcs")}
                                </span>

                                <span className={S.price}>
                                    {line.data?.price?.totalPrice > 0 ? (
                                        formatNumber(line.data?.price?.totalPrice, currentCulture, {
                                            decimals: 2,
                                        })
                                    ) : (
                                        <DA_EmptyStateNoPrice />
                                    )}
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
};
